export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [6,[2]],
		"/embed-previewer": [22],
		"/(embeds)/embeds/en/bracket": [16,[5]],
		"/(embeds)/embeds/en/groups": [17,[5]],
		"/(embeds)/embeds/en/matches-widget": [18,[5]],
		"/(embeds)/embeds/en/referral": [19,[5]],
		"/(embeds)/embeds/en/reuters-match-strip": [20,[5]],
		"/(embeds)/embeds/en/teams-table": [21,[5]],
		"/(app)/groups": [7,[2]],
		"/(app)/groups/results": [8,[2]],
		"/(app)/groups/standings": [9,[2]],
		"/(app)/knockouts": [10,[2]],
		"/(app)/matches/[slugpath]": [11,[2,3]],
		"/(app)/matches/[slugpath]/share": [12,[2,3]],
		"/(app)/schedule": [13,[2]],
		"/sharecards": [23],
		"/(app)/teams/[slug]": [14,[2,4]],
		"/(app)/teams/[slug]/share": [15,[2,4]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';